module.exports = __webpack_public_path__ + "static/13-1aa95410b0f7f05b7b741945be66b81d.jpg";